module.exports = __webpack_public_path__ + "9c8e96ecc7fa01e6ebcd196495ed2db5.svg";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/fonts/themify.svg?v=1.0.0
// module id = 571
// module chunks = 0